/**
 * Copyright © 2020 Redbox Digital Limited. All rights reserved.
 */

define('Magento_Catalog/js/catalog/view/custom-tabs',[
    'jquery',
    'mage/translate',
    'matchMedia',
    'Magento_Theme/js/model/scroll-shadow-mutation-observer',
    'lazyLoadBgImg',
    'mage/mage',
    'jquery/readmore',
    'mage/collapsible',
    'mage/tabs',
    'domReady!'
], function ($, $t, mediaCheck, scrollShadowMutationObserver, lazyLoadBgImg) {
    'use strict';

    return function (config, el) {
        var rbd = rbd || {}; // if namespace is not defined, make it equal to an empty object
        rbd.tabs = {
            /**
             * Initialisation
             */
            init: function () {
                var _self = this;
                lazyLoadBgImg();
                this._shortDesc();
                this._moveToMoreInfo();
                this._showFullOverview();

                mediaCheck({
                    media: '(min-width: 1008px)',

                    /**
                     * Switch to Desktop Version.
                     */
                    entry: function () {
                        _self._categoryLandingText(true);
                    },

                    /**
                     * Switch to Mobile Version.
                     */
                    exit: function () {
                        if ($('.tabs-title-wrapper .tabs-title').length > 0) {
                            scrollShadowMutationObserver.setShadow(
                                '.tabs-title-wrapper',
                                '.tabs-title-wrapper .tabs-title',
                                '.tabs-title-wrapper .tabs-title .item');
                        } else {
                            scrollShadowMutationObserver.initiate(
                                '.tabs-title-wrapper',
                                '.tabs-title-wrapper .tabs-title',
                                '.tabs-title-wrapper .tabs-title .item', function () {
                                });
                        }
                        _self._categoryLandingText();
                    }
                });
            },

            /**
             * Description text Show/hide
             * @private
             */
            _showFullOverview: function () {
                var padv = $('.product.attribute.description .value');
                padv.readmore({
                    speed: 200,
                    collapsedHeight: 320,
                    moreLink: '<a class="toggle-more-less-text" href="#"><span>' + $t('Show full overview') + '</span></a>',
                    lessLink: '<a class="toggle-more-less-text open" href="#"><span>' + $t('Hide full overview') + '</span></a>',
                    embedCSS: false,
                    blockProcessed: function() {
                        padv.find('ul[data-content-type="faq"]').parents('.product.description').addClass('faq-pdp');
                    },
                    afterToggle: function() {
                        var faq = $('.product.description').find('ul[data-content-type="faq"]').length;
                        if(faq) {padv.css('height','auto')}
                    }
                });
            },

            /**
             * Short descriptions show more option
             * @private
             */
            _shortDesc: function () {
                const description = $('.overview .value');
                description.readmore({
                    speed: 200,
                    collapsedHeight: 50,
                    moreLink: '<a class="read-more" href="#">' + $t('Read more') + '</a>',
                    lessLink: '<a class="read-less" href="#">' + $t('Read less') + '</a>',
                    embedCSS: true
                });
            },

            /**
             * Category header text show more option
             * @private
             */
            _categoryLandingText: function (destroy = false) {
                const description = $('.category-description .pagebuilder-column h2');
                if(destroy) {
                    description.readmore('destroy')
                } else {
                    description.readmore({
                        speed: 200,
                        collapsedHeight: 50,
                        moreLink: '<a class="read-more" href="#">' + $t('Read more') + '</a>',
                        lessLink: '<a class="read-less" href="#">' + $t('Read less') + '</a>',
                        embedCSS: true
                    });
                }
            },

            /**
             * Move to tab "More info"
             * @private
             */
            _moveToMoreInfo: function () {
                var _self = this;
                $('.view-phone-details a').on('click', function (event) {
                    event.preventDefault();
                    _self._activateTab($(this).attr('href'));
                });
            },

            /**
             * Activate tab by specfic id
             * @param id
             * @private
             */
            _activateTab: function (id) {
                var anchor = id.replace(/^.*?(#|$)/, '');
                $('.product.data.items [data-role="content"]').each(function (index) {
                    if (this.id == anchor) {
                        $('.product.data.items').tabs('activate', index);
                    }
                });
            }
        }
        rbd.tabs.init();
    }
});

